/*
* params
* shipperPrice: final price that is agreed upon after the negotiation process
* totalPrice: if the priceType is per km, total price is calculated by multiplying per km price with total km if there's a distance
*/

import React, { useEffect } from 'react'
import { GButton, GInput } from 'tennders-common/form/components'
import useTransactions from 'tennders-transactions/hooks/useTransactions'
import { capitalizeFirst, gCurrency, getTotalPrice } from 'tennders-stracture/libs/utils'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import useTranslation from 'next-translate/useTranslation'
import useUpdateBookRate from 'tennders-market/common/hooks/useUpdateBookRate'
import GHref from 'tennders-market/common/components/element/GHref'
import { useDispatch } from 'react-redux'
import { dispatchUpdatePaymentTerms } from 'tennders-common/stores/modal/action'

interface ShipperCurrencyProps {
    transaction: TransactionType;
    detailsClass?: string;
    withoutDetail?: boolean;
    label?: () => JSX.Element;
    editable?: boolean;
    setEditable? : (boolean) =>void;
    isBrokerRowDisplay?: boolean;
}

const ShipperCurrency = ({
  transaction,
  editable,
  setEditable,
  label,
  detailsClass,
  withoutDetail,
  isBrokerRowDisplay
}: ShipperCurrencyProps) => {
  const { refreshTransaction } = useTransactions()
  const { t } = useTranslation()
  const totalPrice = getTotalPrice(transaction, transaction?.matchedLoad?.priceType, transaction?.matchedLoad?.bookRate)
  const shipperPrice = gCurrency(transaction?.matchedLoad?.bookRate)

  const { updatePrice: savePrice, saving, setInputPrice, inputPrice } = useUpdateBookRate({
    transaction,
    setEditable
  })

  const updatePrice = async () => {
    if (await savePrice('load')) {
      refreshTransaction()
    }
  }

  useEffect(() => {
    setInputPrice(transaction?.matchedLoad?.bookRate)
  }, [transaction])

  return (
    isBrokerRowDisplay ? (
      <div className="d-flex text-10">
        {' '}
        <img
          src="/img/loads.svg"
          width="24"
          height="24"
          alt="Load"
          className="mr-8" />
        <div className="d-flex flex-col">
          <strong>
            {transaction.matchedLoad?.priceType}
          </strong>
          {' '}
          {totalPrice ? (
            <span>
              {`${shipperPrice} ${gCurrency(totalPrice) !== shipperPrice ? ` (${gCurrency(totalPrice)}) ` : ''}`}
            </span>
          ) : <span>{shipperPrice}</span> }
          <span> {` ${transaction?.matchedLoad?.paymentTerm?.type}`}</span>
        </div>
      </div>
    ) : (
      <>
        {' '}
        {label()}
        {transaction.matchedLoad?.priceType}
        {' '}
        {editable ? (
          <div className="d-flex row ">
            <GInput onSet={setInputPrice} type="currency" val={inputPrice} />
            <GButton
              submitting={saving}
              onClick={updatePrice}
              className="ml-10 mt-8 mb-2 btn standard-btn cursor-pointer medium"
              labelKey="common:save"
            />
          </div>
        ) : (
          totalPrice ? (
            <span>
              {`${shipperPrice} ${gCurrency(totalPrice) !== shipperPrice ? ` (${gCurrency(totalPrice)}) ` : ''}`}
            </span>
          ) : shipperPrice
        )}
        {withoutDetail
          ? <span className="bold positive-text">{` ${capitalizeFirst(transaction?.matchedLoad?.paymentTerm?.type || '')}`}</span>
          : (
            <>
              <br />
              {t('transaction:paymentTerms')}
              <span className={detailsClass || ''}>
                <>
                  {`  ${transaction?.matchedLoad?.paymentTerm?.type}`}
                  {/* ` / ${transaction?.matchedLoad?.paymentTerm?.dType ? t('common:' + transaction?.matchedLoad?.paymentTerm?.dType) : '-'}` */}
                  {` / ${transaction?.matchedLoad?.paymentTerm?.days || '?'} days`}
                  {` / ${transaction?.matchedLoad?.paymentTerm?.cmrType?.label || ''}`}
                </>
              </span>
            </>
          )}
      </>
    )
  )
}

export default ShipperCurrency
